import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { keyframes } from '@emotion/react';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import useResponsiveValue from '../../../hooks/use-responsive-value.esm.js';
import { useSafeThemeUI } from '../../../theme-provider/use-theme-ui.esm.js';
import { get } from '../../../utils/object.esm.js';
import { resolveSize } from '../../../utils/size-utils.esm.js';
import Box from '../box/box.esm.js';
import Circle from '../svg/circle.esm.js';
import Svg from '../svg/svg.esm.js';

var _excluded = ["className", "size", "strokeWidth", "title", "duration"];
var spin = keyframes({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
var wrapperCss = {
  overflow: 'visible'
};
var Spinner = /*#__PURE__*/React.forwardRef(function Spinner(props, ref) {
  var theme = useSafeThemeUI(props);
  var className = props.className,
    size = props.size,
    strokeWidth = props.strokeWidth,
    title = props.title,
    duration = props.duration,
    rest = _objectWithoutProperties(props, _excluded);
  var r = 16 - strokeWidth;
  var C = 2 * r * Math.PI;
  var offset = C - 1 / 4 * C;
  var spinnerSize = resolveSize(size, get(theme, 'sizes.spinner'));
  var _size = Array.isArray(spinnerSize) ? useResponsiveValue(spinnerSize) : spinnerSize;
  var circleCss = useMemo(function () {
    return {
      transformOrigin: '50% 50%',
      animationName: spin.toString(),
      animationTimingFunction: 'linear',
      animationDuration: duration + 'ms',
      animationIterationCount: 'infinite'
    };
  }, [duration]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classNames({
      'csg-tui-spinner': true
    }, className),
    ref: ref,
    width: _size,
    height: _size
  }, rest), /*#__PURE__*/React.createElement(Box, {
    className: "csg-tui-spinner-auto-size",
    relative: true,
    width: "100%",
    mx: 0,
    my: "auto"
  }, /*#__PURE__*/React.createElement(Svg, {
    id: "svg_spinner",
    viewBox: "0 0 32 32",
    strokeWidth: strokeWidth,
    role: "img",
    __css: wrapperCss
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: r,
    opacity: 1 / 4
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 16,
    cy: 16,
    r: r,
    strokeDasharray: C,
    strokeDashoffset: offset,
    __css: circleCss
  }))));
});
Spinner.defaultProps = {
  size: 'md',
  strokeWidth: 4,
  title: 'Loading...',
  duration: 1000
};

export default Spinner;
//# sourceMappingURL=spinner.esm.js.map
